import { Layout } from "components/layout";
import {
  BrowserRouter,
  Routes,
  Route,
  Outlet,
  useLocation,
  Navigate,
} from "react-router-dom";
import ForgotPassword from "./forgotPassword";
import Login from "./login";
import NotFound from "./NotFound";
import ResetPassword from "./resetPassword";
import SurveyPage from "./survey/addEditSurvey";
import Playground from "./Playground";
import ClearAlertsOnRouteChange from "shared/router/clearAlertsOnRouteChange";
import { SurveyList } from "./survey/list";
import Logout from "./logout";
import { DefaultUnhandledRejectionHandler } from "shared/unhandledRejection/DefaultUnhandledRejectionHandler";
import { UserContainer, useUser } from "shared/auth/user/context";
import { useRunOnMount } from "shared/useRunOnMount/useRunOnMount";
import { useAuthRoutes } from "shared/auth/useAuthRoutes";
import { useState } from "react";
import { ViewReport } from "./survey/report";
import { ToastContainer } from "shared/toast/container";

export default function AppRoutes() {
  return (
    <BrowserRouter>
      <ToastContainer />
      <DefaultUnhandledRejectionHandler />
      <ClearAlertsOnRouteChange />
      <UserContainer>
        <RoutesComponent />
      </UserContainer>
    </BrowserRouter>
  );
}

function RoutesComponent() {
  const { isLoggedIn } = useUser();
  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        <Route
          index
          element={
            isLoggedIn() ? <Navigate to={"site/survey/list"} /> : <Login />
          }
        />
        <Route path="login" element={<Login />} />
        <Route path="logout" element={<Logout />} />
        <Route path="forgotPassword" element={<ForgotPassword />} />
        <Route path="ResetPassword" element={<ResetPassword />} />

        <Route element={<ProtectedRoute />}>
          <Route path="site/survey/list" element={<SurveyList />} />
          <Route
            path="site/survey/edit"
            element={<SurveyPage action="editSurvey" />}
          />
          <Route
            path="site/survey/unit/edit"
            element={<SurveyPage action="editUnit" />}
          />

          <Route path="playground" element={<Playground />} />
        </Route>
      </Route>

      <Route path="/" element={<ProtectedRoute />}>
        <Route path="site/survey/report" element={<ViewReport />}></Route>
      </Route>
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

function ProtectedRoute({
  requiredRole = "",
}: {
  requiredRole?: string | undefined;
}) {
  const { isLoggedIn, hasRole } = useUser();
  const { goToLoginPage } = useAuthRoutes();
  const [show, setShow] = useState(false);
  const location = useLocation();
  useRunOnMount(() => {
    if (!isLoggedIn()) {
      goToLoginPage();
      return;
    }
    if (!requiredRole) {
      setShow(true);
    }
    if (requiredRole && hasRole(requiredRole)) {
      setShow(true);
    }
  });

  return <>{show ? <Outlet key={location.key} /> : null}</>;
}
